import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { StatusBadge } from "@/components/StatusBadge";

export default function DashOrders() {
  const { t } = useI18n();
  const [orders, setOrders] = useState(null);

  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);

  if (orders === null) return <div className="flex justify-center py-20"><Loader2 className="animate-spin text-amber-400" size={36} /></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-extrabold text-white">{t("dash.orders")}</h1>
      {orders.length === 0 ? (
        <div className="card-lux p-10 text-center">
          <p className="text-slate-400">You haven't placed any orders yet.</p>
          <Link to="/services" className="gold-btn mt-4 inline-flex text-sm">Browse Services <ArrowRight size={15} /></Link>
        </div>
      ) : (
        <div className="card-lux overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="orders-table">
              <thead className="bg-black/30 text-slate-500 text-xs uppercase tracking-wide">
                <tr>
                  <th className="text-left px-5 py-3">Order</th>
                  <th className="text-left px-5 py-3">Service</th>
                  <th className="text-left px-5 py-3">Total</th>
                  <th className="text-left px-5 py-3">Network</th>
                  <th className="text-left px-5 py-3">Status</th>
                  <th className="text-right px-5 py-3">Action</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((o) => (
                  <tr key={o.id} className="border-t border-white/5" data-testid={`order-row-${o.order_id}`}>
                    <td className="px-5 py-4 font-mono text-xs text-slate-400">{o.order_id}</td>
                    <td className="px-5 py-4 text-white">{o.service_name}{o.package_name ? ` · ${o.package_name}` : ""}</td>
                    <td className="px-5 py-4 text-white">{o.total} USDT</td>
                    <td className="px-5 py-4 text-slate-400">{o.network}</td>
                    <td className="px-5 py-4"><StatusBadge status={o.status} /></td>
                    <td className="px-5 py-4 text-right">
                      {["Pending Payment", "Payment Detected"].includes(o.status)
                        ? <Link to={`/payment/${o.order_id}`} className="text-amber-400 font-semibold text-xs" data-testid={`pay-link-${o.order_id}`}>Complete Payment</Link>
                        : <span className="text-slate-600 text-xs">—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
